
export const AcademicInfoView = ({ academicData, academicDocument }) => {
  const documentUrl = academicDocument?.url || academicDocument?.documentUrl || academicDocument;

  return (
    <div className="rounded-2xl p-6 border border-slate-700/50">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-white font-bold text-lg">ACADEMIC INFORMATION</h3>
      </div>

      {/* Two-column layout: scores left, transcript right */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* Left — GPA, SAT Score, ACT Score in one row */}
        <div>
          <p className="text-gray-400 text-xs uppercase tracking-widest mb-3">Scores</p>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="block text-gray-400 text-xs uppercase tracking-wide mb-2">GPA</label>
              <div className="w-full px-4 py-3 rounded-lg bg-slate-800/50 border border-slate-600/40 text-white text-center text-sm">
                {academicData?.gpa || '-'}
              </div>
            </div>
            <div>
              <label className="block text-gray-400 text-xs uppercase tracking-wide mb-2">SAT Score</label>
              <div className="w-full px-4 py-3 rounded-lg bg-slate-800/50 border border-slate-600/40 text-white text-center text-sm">
                {academicData?.sat || '-'}
              </div>
            </div>
            <div>
              <label className="block text-gray-400 text-xs uppercase tracking-wide mb-2">ACT Score</label>
              <div className="w-full px-4 py-3 rounded-lg bg-slate-800/50 border border-slate-600/40 text-white text-center text-sm">
                {academicData?.act || '-'}
              </div>
            </div>
          </div>
        </div>

        {/* Right — Academic Transcript */}
        <div>
          <p className="text-gray-400 text-xs uppercase tracking-widest mb-3">Academic Transcript</p>
          {documentUrl ? (
            <a href={documentUrl} target="_blank" rel="noopener noreferrer" className="block group">
              <div className="relative p-3 rounded-xl bg-slate-800/50 border border-slate-600/40 hover:border-cyan-500/50 transition-all flex items-center gap-3">
                <div className="w-10 h-10 bg-cyan-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-xs font-bold">PDF</span>
                </div>
                <span className="text-slate-300 text-sm truncate group-hover:text-white transition-colors">
                  Academic Transcript
                </span>
                <svg className="w-4 h-4 text-slate-400 group-hover:text-cyan-400 flex-shrink-0 ml-auto" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
            </a>
          ) : (
            <div className="p-3 rounded-xl bg-slate-800/50 border border-slate-600/40 text-center">
              <p className="text-slate-400 text-sm">No transcript uploaded</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AcademicInfoView;
